// Client-side handoff cache for Piks News articles.
//
// The news list (and any news chip/rail) already holds the full article
// metadata (headline, image, league, source, description…). When the user
// taps through to /news/[slug], we stash that object here so the reader
// page can paint the entire article INSTANTLY — no fetch, no loader.
//
// A module-level Map covers client-side navigations; sessionStorage backs
// refreshes within the same tab. Cold deep-links fall back to the API.

const mem = new Map(); // id -> article

const SS_KEY = 'piks:news:article:'; // + id

export function rememberArticle(article) {
  if (!article || !article.id) return;
  mem.set(article.id, article);
  try {
    sessionStorage.setItem(SS_KEY + article.id, JSON.stringify(article));
  } catch {
    // storage full / private mode — memory cache still works
  }
}

export function recallArticle(id) {
  if (!id) return null;
  const hit = mem.get(id);
  if (hit) return hit;
  try {
    const raw = sessionStorage.getItem(SS_KEY + id);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && parsed.id === id) {
        mem.set(id, parsed);
        return parsed;
      }
    }
  } catch {
    // ignore
  }
  return null;
}
